import fp from 'micro-fp';
import runes from 'runes';

import emojis from '../directives/emoji.json';

const allEmojisArray = Object.keys(emojis).reduce(
  (reduced, cat) => [...reduced, ...emojis[cat].split(',')],
  []
);

const emojisCodePointsDict = allEmojisArray.reduce(
  (dict, emoji) => ((dict[emoji.codePointAt(0)] = true), dict),
  {}
);

export default function emoticonize() {
  // Try to stick to the emoticon codes as used by GitHub, Campfire, Basecamp, Flowdock, Slack.. etc.
  // See http://www.emoji-cheat-sheet.com for a list.

  const table = {
    '🔥': [':fire:'],
    '💩': [':shit:', ':hankey:', ':poop:'],
    '🙏': [':pray:'],
    '😉': [':wink:', ';)', ';-)'],
    '😄': [':smile:', ':)', ':-)'],
    '😊': [':blush:'],
    '😺': [':smiley_cat:'],
    '😸': [':smile_cat:'],
    '😖': [':confounded:'],
    '😌': [':relieved:'],
    '😳': [':flushed:'],
    '😍': [':heart_eyes:'],
    '👽': [':alien:'],
    '👊': [':facepunch:', ':punch:'],
    '👏': [':clap:'],
    '😎': [':sunglasses:', '8)', '8-)'],
    '😆': [':laughing:'],
    '😀': [':grinning:', ':D', ':-D'],
    '😃': [':smiley:', '=D', '=-D'],
    '😁': [':grin:'],
    '😠': ['>:(', '>:-(', ':angry:'],
    '😑': [':|', ':-|', ':expressionless:'],
    '😕': [':confused:', ':/', ':-/'],
    '😛': [':stuck_out_tongue:', ':p', ':-p', ':P', ':-P'],
    '😜': [':stuck_out_tongue_winking_eye:', ';p', ';-p', ';P', ';-P'],
    '😝': [':stuck_out_tongue_closed_eyes:'],
    '😞': [':disappointed:', ':(', ':-('],
    '😒': [':unamused:'],
    '😢': [":'(", ":'-(", ':cry:'],
    '😂': [':joy:'],
    '😭': [':sob:'],
    '😓': [':sweat:'],
    '😱': [':scream:', ':o', ':O', ':-o', ':-O'],
    '😰': [':cold_sweat:'],
    '😨': [':fearful:'],
    '😶': [':no_mouth:'],
    '😗': [':kissing:', ':*'],
    '😚': [':kissing_closed_eyes:'],
    '😙': [':kissing_smiling_eyes:'],
    '😟': [':worried:'],
    '😇': [':innocent:'],
    '😡': [':rage:'],
    '😷': [':mask:'],
    '👍': [':thumbsup:', ':+1:'],
    '👎': [':thumbsdown:', ':-1:'],
    '💛': [':<3:', ':yellow_heart:', ':heart:'],
    '💥': [':boom:', ':collision:'],
    '✨': [':sparkles:'],
    '🎉': [':tada:'],
    '💯': [':100:'],
  };

  function _escapeRegExp(string) {
    return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'); // eslint-disable-line
  }

  const replaceWith = fp.curry((replace, string, find) => {
    const pre = '(^|[\\s\\0])';
    return string.replace(new RegExp(`${pre}(${_escapeRegExp(find)})`, 'g'), `$1${replace}`);
  });

  function processEmoji(_text, emoji) {
    return fp.compose(fp.reduce(replaceWith(emoji), _text), fp.prop(emoji))(table);
  }

  function wrapInSpans(text) {
    // String.prototype.split is not very good at splitting strings wirth unicode (with surrogat pairs) characters
    return runes(text)
      .map((characterArg) => {
        let str = characterArg;
        if (emojisCodePointsDict[str.codePointAt(0)]) {
          if (str === '🔥') {
            str += '<canvas class="flame-canvas" width="300" height="400"></canvas>';
          }

          return `<span class="emoji">${str}</span>`;
        }
        return str;
      })
      .join('');
  }

  return function link(text, showEmoticons) {
    if (!text || !showEmoticons) {
      return text;
    }

    return fp.compose(wrapInSpans, fp.reduce(processEmoji, text), fp.keys)(table);
  };
}
